import React from 'react';
import classNames from 'classnames';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*2,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  total: {
    minWidth: '75px',
  },
});

const Quote = ({ classes, task }) => {
  return(
    <div className={classes.root}>
      {task.labor &&
        <div className={classes.column}>
          <Typography variant="subheading">
            ${task.labor.reduce((total, task) => {
              return total + task.quantity*task.rate;
            }, 0)}
          </Typography>
          <Typography variant="caption">
            Labor ({task.labor.length})
          </Typography>
        </div>
      }
      {task.materials &&
        <div className={classes.column}>
          <Typography variant="subheading">
            ${task.materials.reduce((total, task) => {
              return total + task.quantity*task.rate;
            }, 0)}
          </Typography>
          <Typography variant="caption">
            Materials ({task.materials.length})
          </Typography>
        </div>
      }
      <div className={classes.divider}></div>
      <div className={classNames(classes.column, classes.total)}>
        <Typography variant="subheading">
          $8700
        </Typography>
      </div>
      <div className={classes.divider}></div>
    </div>
  );
};

export default withStyles(styles)(Quote);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/Total/Quote.jsx